import { useState } from 'react';
import { Box, MenuItem, Typography, IconButton } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

import Dropdown from './Dropdown';

export default function HeaderDropdown({ title, icon, items = [], label = null, className = '' }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (item) => {
    if (item.callback) {
      item.callback();
    }
    handleClose();
  };

  return (
    <Box>
      <IconButton
        onClick={handleClick}
        className={`flex items-center gap-8 bg-white text-gray-700 px-16 py-8 rounded-8 hover:bg-gray-50 border border-gray-200 ${className}`}
        sx={{
          backgroundColor: 'white',
          color: '#374151', // dark grey
          borderRadius: '8px',
          padding: '8px 16px',
          border: '1px solid #e5e7eb',
          '&:hover': {
            backgroundColor: '#f9fafb',
          },
        }}
      >
        {icon && <Box className="w-16 h-16">{icon}</Box>}
        <Typography className="font-medium text-14 text-gray-700">{title}</Typography>
        <ExpandMore className="w-16 h-16" />
      </IconButton>

      <Dropdown label={label} anchorEl={anchorEl} opened={open} handleClose={handleClose}>
        {items.map((item) => (
          <MenuItem
            key={item.id || item.title}
            onClick={() => handleItemClick(item)}
            className="px-16 py-12"
          >
            <Typography className="text-14 text-gray-700">{item.title}</Typography>
          </MenuItem>
        ))}
      </Dropdown>
    </Box>
  );
}
